<template>
    <button class="row__button">
        <SvgIcon v-if="props.icon" :name="props.icon" />
        <slot v-else />
    </button>
</template>

<script>
export default {
    name: 'RowButton',
};
</script>

<script setup>
import SvgIcon from '@/components/ui/SvgIcon';

const props = defineProps({
    icon: {
        type: String,
        default: '',
    },
});
</script>

<style src="./styles.scss" lang="scss" scoped />
